import { render, staticRenderFns } from "./performanceDetail.vue?vue&type=template&id=06787975&scoped=true&"
import script from "./performanceDetail.vue?vue&type=script&lang=js&"
export * from "./performanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./performanceDetail.vue?vue&type=style&index=0&id=06787975&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06787975",
  null
  
)

export default component.exports